<template>
	<div ref="test">
		<div v-if="dataObject" class="panel m-3">
			<PanelHeader panel-header="Darreichungsform (Art)" />
			<div class="container pt-3 pb-3">
				<div class="columns">
					<div class="column">
						<b-field label="Bezeichner">
							<p class="content">
								{{ icd10CodeName }}
							</p>
						</b-field>
					</div>
					<div class="column">
						<b-field label="ICD-10-Code">
							<p class="content">
								{{ icd10Code }}
							</p>
						</b-field>
					</div>
				</div>
			</div>
		</div>
		<div>
			<section class="m-5">
				<b-button class="is-danger" tag="router-link" to="/icd_10">
					Zurück
				</b-button>
			</section>
		</div>
	</div>
</template>
  
<script>
/**
 * This file is for viewing a focused medication form.
 */

import PanelHeader from "@/components/helperComponents/PanelHeader";

export default {
	name: "ViewICD10",
	components: {
		PanelHeader,
	},
	data() {
		return {
			dataObject: undefined,
			icd10CodeName: "",
			icd10Code: "",
		};
	},
	computed: {},
	mounted() {
		this.scrollToElement()
		if (this.$route.params.data) {
			this.dataObject = this.$route.params.data
			this.icd10CodeName = this.dataObject.attributes.name
			this.icd10Code = this.dataObject.attributes.icd_10_code
		}
	},
	methods: {
		scrollToElement() {
			const el = this.$parent.$parent.$refs.scrollToMe;
			if (el) {
				el.scrollIntoView({ behavior: 'smooth' });
			}
		}
	}
}
</script>
  
<style lang="scss" scoped>
.image_column {
	max-width: 200px;
}
</style>
  